export default "__VITE_ASSET__AQ97jx7p__"